import { gql } from '@apollo/client';

export const M_LOCATION_CREATE = gql`
  mutation locationCreate($input: InputLocationCreate!) {
      locationCreate(input: $input) {
      message
    }
  }
`;

export const M_LOCATION_UPDATE = gql`
  mutation locationUpdate($input: InputLocationUpdate!) {
    locationUpdate(input: $input) {
      message
    }
  }
`;

export const M_LOCATION_DELETE = gql`
  mutation locationDelete($input: InputId!) {
    locationDelete(input: $input) {
      message
    }
  }
`;

export const M_LOCATIONS = gql`
  mutation locations($input: InputFetchLocations!) {
    locations(input: $input) {
      count
      rows {
        id
        name
        title
        active
          created
      }
    }
  }
`;

// fetchAgentLocations
export const M_FETCH_AGENT_LOCATIONS = gql`
  mutation fetchAgentLocations {
      fetchAgentLocations {
          rows{
              id
              location_name
          }
    }
  }
`;

export const M_AGENT_LOCATION_OPTIONS = gql`
  mutation agentLocationOptions($input: InputAgentLocationOptions!) {
    agentLocationOptions(input: $input) {
      key
      source
      label
      locationId
      latitude
      longitude
      bbox
      placeType
    }
  }
`;
